import { render, staticRenderFns } from "./ProductPropertyList.vue?vue&type=template&id=6e08bc29&"
import script from "./ProductPropertyList.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports